import { render, staticRenderFns } from "./WaitingDoctor.vue?vue&type=template&id=b960ecea&scoped=true&"
import script from "./WaitingDoctor.vue?vue&type=script&lang=js&"
export * from "./WaitingDoctor.vue?vue&type=script&lang=js&"
import style0 from "./WaitingDoctor.vue?vue&type=style&index=0&id=b960ecea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b960ecea",
  null
  
)

export default component.exports